"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _utils = require("../../../../utils");

var _Image = _interopRequireDefault(require("../../../Icon/Image"));

var _FontAwesome = _interopRequireDefault(require("../../../Icon/FontAwesome"));

var _employer_card_top = _interopRequireDefault(require("./employer_card_top.png"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Interactive ID Badge Component
 */
var EmployerBadge =
/*#__PURE__*/
function (_Component) {
  _inherits(EmployerBadge, _Component);

  function EmployerBadge(props) {
    var _this;

    _classCallCheck(this, EmployerBadge);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EmployerBadge).call(this, props));
    _this.state = {
      height: 320,
      width: 240,
      mouseX: 0,
      mouseY: 0,
      mouseLeaveDelay: null,
      el: null
    };
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_assertThisInitialized(_this));
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_assertThisInitialized(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(EmployerBadge, [{
    key: "mousePX",
    value: function mousePX() {
      return this.state.mouseX / this.state.width;
    }
  }, {
    key: "mousePY",
    value: function mousePY() {
      return this.state.mouseY / this.state.height;
    }
  }, {
    key: "cardStyle",
    value: function cardStyle() {
      // TODO: Fix the math
      // const rX = this.mousePX() * 3;
      // const rY = this.mousePY() * -.05;
      return {// transform: `rotateY(${rX}deg) rotateX(${rY}deg)`
      };
    }
  }, {
    key: "cardBgStyle",
    value: function cardBgStyle() {
      var _this$props = this.props,
          image = _this$props.image,
          location = _this$props.location;
      var bgImage = image || location && location.image;
      if (!bgImage) return {}; // TODO: Fix the math
      // const tX = this.mousePX() * -6;
      // const tY = this.mousePY() * -.05;

      return {
        backgroundImage: "url(".concat(bgImage, ")") // transform: `translateX(${tX}px) translateY(${tY}px)`

      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = _reactDom.default.findDOMNode(this);

      var card = node.querySelector('.story-employer-badge');
      this.setState({
        el: card,
        height: card.offsetHeight,
        width: card.offsetWidth
      });
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(e) {
      var _getOffsetOfElementIn = (0, _utils.getOffsetOfElementInViewport)(this.state.el),
          top = _getOffsetOfElementIn.top,
          left = _getOffsetOfElementIn.left;

      this.setState({
        mouseX: e.pageX - left - this.state.width / 2,
        mouseY: e.pageY - top - this.state.height / 2
      });
    }
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      clearTimeout(this.state.mouseLeaveDelay);
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      var _this2 = this;

      this.setState({
        mouseLeaveDelay: setTimeout(function () {
          _this2.setState({
            mouseX: 0,
            mouseY: 0
          });
        }, 1000)
      });
    }
  }, {
    key: "renderLogo",
    value: function renderLogo() {
      var logo = this.props.logo;
      return logo && _react.default.createElement("div", {
        className: "badge-logo"
      }, _react.default.createElement(_Image.default, {
        url: logo
      }));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var qualifiers = this.props.qualifiers;
      return qualifiers && _react.default.createElement("div", {
        className: "badge-content"
      }, Object.values(qualifiers).map(function (_ref) {
        var label = _ref.label,
            values = _ref.values;
        return _react.default.createElement("div", {
          className: "badge-content__item"
        }, _react.default.createElement("div", {
          className: "badge-content__item__prop"
        }, label, " :"), Object.keys(values).map(function (label) {
          return _react.default.createElement("div", {
            className: "badge-content__item__value"
          }, label);
        }));
      }));
    }
  }, {
    key: "renderInfoPanel",
    value: function renderInfoPanel() {
      var _this$props2 = this.props,
          accentColor = _this$props2.accentColor,
          description = _this$props2.description,
          label = _this$props2.label,
          location = _this$props2.location,
          textColor = _this$props2.textColor,
          website = _this$props2.website;
      var colorStyle = {
        color: accentColor,
        background: textColor
      };
      return _react.default.createElement("div", {
        className: "badge-info-panel-container"
      }, _react.default.createElement("div", {
        className: "badge-info-panel",
        style: colorStyle
      }, _react.default.createElement("div", {
        className: "badge-info-panel__icon"
      }, _react.default.createElement(_FontAwesome.default, {
        name: "FaInfoCircle"
      })), _react.default.createElement("div", {
        className: "badge-info-panel__body",
        style: colorStyle
      }, _react.default.createElement("div", {
        className: "employer-info"
      }, _react.default.createElement("div", {
        className: "badge-info-panel__body__row row-header"
      }, label), _react.default.createElement(_core.Divider, {
        style: {
          backgroundColor: accentColor
        }
      }), description && _react.default.createElement("div", {
        className: "badge-info-panel__body__row"
      }, description), location && location.label && _react.default.createElement("div", {
        className: "badge-info-panel__body__row"
      }, _react.default.createElement("span", {
        className: "badge-info-panel__body__row__prop"
      }, "Location:"), location.label, location.image && _react.default.createElement(_Image.default, {
        url: location.image
      })), website && _react.default.createElement("div", {
        className: "badge-info-panel__body__row"
      }, _react.default.createElement(_core.Button, {
        className: "employer-info-box__button",
        href: website,
        target: "_blank",
        style: {
          color: accentColor
        }
      }, "Learn More"))))));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "story-employer-badge-container"
      }, _react.default.createElement("div", {
        className: "story-employer-badge",
        style: this.cardStyle(),
        onMouseMove: this.handleMouseMove,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, _react.default.createElement("div", {
        className: "badge-graphic-top"
      }, _react.default.createElement("img", {
        src: _employer_card_top.default
      })), _react.default.createElement("div", {
        className: "badge-inner"
      }, this.renderInfoPanel(), _react.default.createElement("div", {
        className: "badge-inner__bg",
        style: this.cardBgStyle()
      }), _react.default.createElement("div", {
        className: "badge-body"
      }, this.renderLogo(), this.renderContent()))));
    }
  }]);

  return EmployerBadge;
}(_react.Component);

exports.default = EmployerBadge;

_defineProperty(EmployerBadge, "propTypes", {
  /** Determines the foreground color of the info panel. */
  accentColor: _propTypes.default.string,

  /** Description of the Employer. */
  description: _propTypes.default.string,

  /** The destination URL of the Employer's image */
  image: _propTypes.default.string,

  /** The name of the Employer. */
  label: _propTypes.default.string.isRequired,

  /** Location data of the Employer. */
  location: _propTypes.default.object,

  /** The destination URL of the Employer's logo */
  logo: _propTypes.default.string,

  /** Additional information to render on the `Badge`'s body. */
  qualifiers: _propTypes.default.object,

  /** Determines the background color of the info panel. */
  textColor: _propTypes.default.string
});

_defineProperty(EmployerBadge, "defaultProps", {
  accentColor: '#3d3547',
  textColor: '#edeaea'
});